import _ from 'underscore';
import Globalize from 'globalize';
import 'globalize/lib/cultures/globalize.culture.de.js';

/**
 * Ensures that numbers only have the minimum number of decimal digits.
 */
const baseFormat = Globalize.format;

Globalize.format = function (value, format, cultureSelector) {
    // make sure that "n" is used as format if no other format is specified
    // otherwise Globalize would use the browser's toLocalizedString method
    if (_.isNumber(value) && _.isUndefined(format)) {
        format = 'n';
    }

    let formattedValue = baseFormat.apply(Globalize, [value, format, cultureSelector]);

    // only modify decimal digits for numbers formatted with the 'n' format
    if (_.isNumber(value) && format === 'n') {
        const decimalSeparator = Globalize.culture().numberFormat['.'];
        const arrFormattedValue = formattedValue.split(decimalSeparator);

        // remove all trailing zeros from the decimal digits
        const decimalDigits = arrFormattedValue[1].replace(/0*$/, '');

        // if there are no decimal digits left, return just the integer value
        if (decimalDigits.length === 0) {
            formattedValue = arrFormattedValue[0];

        // else join integer value and remaining decimal digits with the regionalized decimal separator
        } else {
            formattedValue = arrFormattedValue[0] + decimalSeparator + decimalDigits;
        }
    }

    return formattedValue;
};

/**
 * Sets language and currency symbol.
 */
const { config, pageModel } = window.POne;
Globalize.culture(config.culture);
_.extend(Globalize.culture().messages, pageModel.i18n.messages);
Globalize.culture().numberFormat.currency.symbol = config.currency;


// WEBPACK FOOTER //
// ./init/globalize.js